import { Pipe, PipeTransform } from '@angular/core';
import { IAgent, IAgentsResponse } from '../../../shared/models/agents.model';

@Pipe({
  name: 'agentGroups',
  standalone: true,
})
export class AgentGroupsPipe implements PipeTransform {
  transform(agents: IAgentsResponse | null, siteName?: string, accountName?: string): IAgentGroup[] {
    if (!agents || !accountName || !siteName) {
      return [];
    }

    return [
      {
        label: '',
        items: agents.callCenterAgents.map((agent) => ({ ...agent, isCallCenterAgent: true })),
      },
      {
        label: `Agents at ${siteName}`,
        items: agents.siteAgents,
      },
      {
        label: `Other ${accountName} Agents`,
        items: agents.accountAgents,
      },
    ];
  }
}

interface IAgentGroup {
  label: string;
  items: IAgent[];
}
